import { Typography } from '@axafr-btc-ds/typography';
import React from 'react';
import { ModalHeaderSkeleton } from './skeleton';
import { cx } from '@emotion/css';
import { headerTitle, leftPicto, modalHeader, pictoContent, titleHeaderPopin } from './header-css';
export var ModalHeader = function (_a) {
    var Icon = _a.icon, title = _a.title, isContentReady = _a.isContentReady, size = _a.size, id = _a.id;
    return isContentReady ? (React.createElement("div", { className: cx(modalHeader(size)) },
        Icon && React.createElement("div", { className: pictoContent },
            React.createElement(Icon, { className: leftPicto }),
            " "),
        React.createElement("div", { className: headerTitle },
            React.createElement(Typography, { variant: "title2", id: id, className: titleHeaderPopin }, title)))) : (React.createElement(ModalHeaderSkeleton, null));
};
